var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"level app-levelbar",staticStyle:{"padding":"4px"}},[_c('div',{staticClass:"level-left"},[_c('div',{staticClass:"level-item"},[_c('span',{staticClass:"level-title is-5"},[_c('strong',[_vm._v(_vm._s(_vm.menu.name))])])]),_c('div',{staticStyle:{"white-space":"pre-line"}},[_vm._v(_vm._s(_vm.menu.desc))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }